// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,generate_name_parser=true"
// @generated from file ai/h2o/mlops/deployer/v2/security.proto (package ai.h2o.mlops.deployer.v2, syntax proto3)
/* eslint-disable */

/**
 * Represents the security properties of a Deployment, defining authentication mechanisms.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.Security
 */
export type Security = {
/**
 * Date when security was updated
 *
 * @generated from field: google.protobuf.Timestamp update_time = 4;
 */
updateTime?: string;
}
 & (
{ 
/**
 * Authentication using a passphrase.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.AuthenticationPassphrase passphrase = 1;
 */
passphrase?: AuthenticationPassphrase;
 }
 | 
{ 
/**
 * Authentication using an authorization access token.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.AuthorizationAccessToken token_auth = 2;
 */
tokenAuth?: AuthorizationAccessToken;
 }
 | 
{ 
/**
 * Disables security.
 * This option should be used with caution as it allows unauthenticated access.
 *
 * @generated from field: google.protobuf.Empty disabled_security = 3;
 */
disabledSecurity?: {} | null;
 }
)
;
/**
 * A passphrase is expected to be supplied in an `Authorization` header
 * in the form `Authorization: Bearer <passphrase>`.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.AuthenticationPassphrase
 */
export type AuthenticationPassphrase = {
/**
 * The plaintext passphrase to authenticate with. When algorithm is not plain text, it won't be returned in response.
 *
 * @generated from field: string passphrase = 1;
 */
passphrase: string;
/**
 * Specifies which hashing algorithm the backend should use for verification
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.AuthenticationPassphrase.HashAlgorithm hash_algorithm = 3;
 */
hashAlgorithm: AuthenticationPassphrase_HashAlgorithm;
}
;
/**
 * Enum representing available hashing algorithms for password verification
 *
 * @generated from enum ai.h2o.mlops.deployer.v2.AuthenticationPassphrase.HashAlgorithm
 */
export enum AuthenticationPassphrase_HashAlgorithm {
/**
 * Unspecified algorithm
 *
 * @generated from enum value: HASH_ALGORITHM_UNSPECIFIED = 0;
 */
HASH_ALGORITHM_UNSPECIFIED = "HASH_ALGORITHM_UNSPECIFIED",

/**
 * Compare as plaintext (not recommended for production)
 *
 * @generated from enum value: PLAINTEXT = 1;
 */
PLAINTEXT = "PLAINTEXT",

/**
 * Use bcrypt hashing algorithm
 *
 * @generated from enum value: BCRYPT = 2;
 */
BCRYPT = "BCRYPT",

/**
 * Use pbkdf2 hashing algorithm
 *
 * @generated from enum value: PBKDF2 = 3;
 */
PBKDF2 = "PBKDF2",
}
/**
 * An access token is expected to be supplied in an `Authorization` header
 * in the form of `Authorization: Bearer <token>`.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.AuthorizationAccessToken
 */
export type AuthorizationAccessToken = {
/**
 * The type of protocols for authentication.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.AuthorizationAccessToken.AuthorizationProtocolSecurityType authentication_protocol = 1;
 */
authenticationProtocol: AuthorizationAccessToken_AuthorizationProtocolSecurityType;
}
;
/**
 * Enum representing the security protocol type.
 *
 * @generated from enum ai.h2o.mlops.deployer.v2.AuthorizationAccessToken.AuthorizationProtocolSecurityType
 */
export enum AuthorizationAccessToken_AuthorizationProtocolSecurityType {
/**
 * Unspecified
 *
 * @generated from enum value: AUTHORIZATION_PROTOCOL_SECURITY_TYPE_UNSPECIFIED = 0;
 */
AUTHORIZATION_PROTOCOL_SECURITY_TYPE_UNSPECIFIED = "AUTHORIZATION_PROTOCOL_SECURITY_TYPE_UNSPECIFIED",

/**
 * OpenID Connect protocol.
 *
 * @generated from enum value: OIDC = 1;
 */
OIDC = "OIDC",
}
